import { __require as requireStringify } from './stringify.js';
import { __require as requireParse } from './parse.js';
import { __require as requireFormats } from './formats.js';

var lib;
var hasRequiredLib;

function requireLib () {
	if (hasRequiredLib) return lib;
	hasRequiredLib = 1;

	var stringify = /*@__PURE__*/ requireStringify();
	var parse = /*@__PURE__*/ requireParse();
	var formats = /*@__PURE__*/ requireFormats();

	lib = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};
	return lib;
}

export { requireLib as __require };
